const mole = 'upload';

export default {
  // 上传图片
  uploadImg: params => {
    return fetch(`/api/${mole}/img`, {
      method: 'POST',
      body: params
    }).then(response => response.json());
  }
};
